import { JSONSchemaType } from 'ajv';

import { t } from '../../config/translations';
import { OrderWithoutLines } from '../types';

export const orderSchema: JSONSchemaType<OrderWithoutLines> = {
  title: 'Order',
  type: 'object',
  properties: {
    ndoc: {
      type: 'integer',
      get title() {
        return t('schema.orderNumber');
      },
      decorators: { search: true },
    },
    mdtt: {
      type: 'string',
      get title() {
        return t('schema.totalAmount');
      },
      decorators: { search: true, numeral: { currencySymbol: '€' } },
    },
    dtac: {
      type: 'integer',
      get title() {
        return t('schema.receptionDate');
      },
      decorators: {
        search: true,
        // `dtac` is an Eureka yyyyMMdd integer, not a Unix timestamp: reading it
        // as seconds rendered 20260706 as 23/08/1970. Same config as orderList.
        dateFormat: {
          stringFormat: 'dd/MM/yyyy',
          isNumber: { actualFormat: 'yyyyMMdd' },
        },
      },
    },
    etat: {
      type: 'string',
      get title() {
        return t('schema.status');
      },
      uniforms: {
        checkboxes: true,
        options: [
          { label: 'ANNULEE', value: '05ANNULEE', color: 'blue' },
          { label: 'ERREUR', value: '99ERREUR', color: 'blue' },
          { label: 'ENSTATS', value: '60ENSTATS', color: 'blue' },
          { label: 'FACTUREE', value: '50FACTUREE', color: 'blue' },
          { label: 'EXPEDIEE', value: '40EXPEDIEE', color: 'blue' },
          { label: 'PREPA', value: '20PREPA', color: 'blue' },
          { label: 'RESERVEE', value: '10RESERVEE', color: 'blue' },
          { label: 'SAISIE', value: '00SAISIE', color: 'blue' },
        ],
      },
      decorators: { search: true },
    },
    type: {
      type: 'string',
      get title() {
        return t('schema.type');
      },
      decorators: { hide: ['details'] },
    },
  },
  required: [],
};
